import { type Translate } from '@legacy/hooks/locale';

// The auth service serialises `{ error: HttpError.message }`, i.e. raw English
// machine tokens (INVALID_EMAIL, "Could not request auth code"). Rendering
// those verbatim put English in front of brokers working in five other
// languages; the sibling phone screens already map instead of forwarding
// (see ResendCodeButton: "Auth's rate-limit refusal is a machine token").
// The raw value still reaches the console so a devtools screenshot stays
// useful, which is what the no-obfuscated-errors rule is after.
export const describeAuthError = (
  detail: string | null | undefined,
  t: Translate,
): string => {
  if (detail != null) {
    console.error('auth request failed', detail);
  }
  switch (detail) {
    case 'INVALID_EMAIL':
      return t('This email address is not valid.');
    case 'TOO_MANY_REQUESTS':
      return t('Please wait a moment before requesting another code.');
    default:
      return t('somethingWentWrong');
  }
};
